import { Box, Flex } from "@chakra-ui/react";
import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useAiInterviewerEnabled } from "../../../hooks/useAiInterviewerEnabled";
import {
  AgenticIntakeVerticalStepper,
  useAgenticIntakeEnabled,
} from "../../components/AiInterviewerWizard/AgenticIntake";
import { AgenticWizardTabBar } from "../../components/AiInterviewerWizard/AgenticIntake/AgenticWizardTabBar";
import AiInterviewerWizard from "../../components/AiInterviewerWizard/AiInterviewerWizard";
import { AiInterviewerWizardContext } from "../../components/AiInterviewerWizard/AiInterviewerWizardContext";
import {
  FlexIntakeVerticalStepper,
  useFlexIntakeEnabled,
} from "../../components/AiInterviewerWizard/FlexIntake";
import { WizardEditorHeader } from "../../components/AiInterviewerWizard/WizardEditorHeader";
import { DefaultLayout } from "../../layouts";

const AiInterviewerPage: React.FC = () => {
  const enableDetailPageUI = useAiInterviewerEnabled();
  const flexIntakeEnabled = useFlexIntakeEnabled();
  const agenticIntakeEnabled = useAgenticIntakeEnabled();

  const {
    wizardOn,
    currentStep,
    steps,
    readOnly,
    subStepDisplay,
    agenticStepIndex,
    agenticSubStepIndex,
    stepperJobTitle,
    wizardHeaderProps,
    guideAssistantVisible,
  } = useContext(AiInterviewerWizardContext);

  if (!enableDetailPageUI) {
    return <Navigate to="/not-found" />;
  }

  if (agenticIntakeEnabled) {
    return (
      <DefaultLayout>
        <Flex direction="column" h="100vh" minW="0" overflow="hidden">
          {wizardHeaderProps && (
            <WizardEditorHeader
              aiInterviewer={wizardHeaderProps.aiInterviewer}
              saving={wizardHeaderProps.saving}
              isDirty={wizardHeaderProps.isDirty}
              isAgentic={wizardHeaderProps.isAgentic}
            />
          )}
          <Flex
            direction="column"
            flex="1"
            minW="0"
            overflow="hidden"
            bg={wizardOn ? "rgba(7, 114, 208, 0.04)" : undefined}
            px={wizardOn ? "8" : "0"}
            pt={wizardOn ? "8" : "0"}
          >
            {wizardOn && wizardHeaderProps && <AgenticWizardTabBar />}
            <Flex direction="row" flex="1" minW="0" overflow="hidden">
              {wizardOn && (
                <AgenticIntakeVerticalStepper
                  currentStep={agenticStepIndex}
                  currentSubStep={agenticSubStepIndex}
                  jobTitle={
                    wizardHeaderProps ? undefined : stepperJobTitle || undefined
                  }
                  collapsed={guideAssistantVisible}
                />
              )}
              <Flex direction="column" flex="1" minW="0" overflow="auto">
                <Outlet />
              </Flex>
              {wizardOn && (
                <Box
                  w="180px"
                  flexShrink={0}
                  display={{ base: "none", "2xl": "block" }}
                />
              )}
            </Flex>
          </Flex>
        </Flex>
      </DefaultLayout>
    );
  }

  if (flexIntakeEnabled) {
    return (
      <DefaultLayout>
        <Flex
          direction="row"
          h="100vh"
          minW="0"
          overflow="hidden"
          bg={wizardOn ? "rgba(7, 114, 208, 0.04)" : undefined}
          p={wizardOn ? "8" : "0"}
        >
          {wizardOn && (
            <FlexIntakeVerticalStepper
              currentStep={currentStep}
              steps={steps}
              activeStepDescription={subStepDisplay?.description}
              title={subStepDisplay?.stepperTitle}
            />
          )}
          <Flex direction="column" flex="1" minW="0" overflow="auto">
            <Outlet />
          </Flex>
          {wizardOn && <Box w="180px" flexShrink={0} />}
        </Flex>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout>
      <Flex direction="column" h="100vh" minW="0" overflow="hidden">
        {wizardOn && (
          <AiInterviewerWizard
            step={currentStep}
            steps={steps}
            readOnly={readOnly}
          />
        )}
        <Outlet />
      </Flex>
    </DefaultLayout>
  );
};

export default AiInterviewerPage;
